import React, { InputHTMLAttributes, forwardRef, ReactNode } from 'react';
import classNames from 'classnames';

export interface RadioButtonProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  name: string;
  label: ReactNode;
  ariaDescribedby?: string;
}

/**
 * The RadioButton Component based on [The USWDS RadioButton component](https://designsystem.digital.gov/components/form-controls/#radio-buttons)
 */
const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ className, id, name, label, value, ariaDescribedby, ...rest }: RadioButtonProps, ref): JSX.Element => {
    return (
      <div className={classNames('usa-radio', className)}>
        <input
          aria-describedby={ariaDescribedby}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...rest}
          id={id}
          name={name}
          ref={ref}
          value={value ?? id}
          type="radio"
          className="usa-radio__input"
        />
        <label className="usa-radio__label" htmlFor={id}>
          {label}
        </label>
      </div>
    );
  },
);

export default RadioButton;
